import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: grid;
  place-items: center;
  background-image: url("https://i.ytimg.com/vi/LgtRqwfJGbI/maxresdefault.jpg");
  background-size: cover;

  section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    height: 50%;
  }

  h1 {
    font-size: 3rem;
    text-shadow: 2px 2px 10px rgba(0, 0, 0, 1);
  }
`;
